
import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import LeftMenu from '../../../Components/LeftMenu/LeftMenu';
import { Button, Modal, Form, Table } from 'react-bootstrap';
import Trash from "../../../assets/images/trash.png";
import Edit from "../../../assets/images/edit.png";
import Setting_user from "../../../assets/images/setting_user.png";
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import Overview from '../../../Airline/ULDControl/components/inc/Overview';
import Overview from '../../Airline/ULDControl/components/inc/Overview';

import { withoutRFSToken, withRFSToken } from '../../../Services/axios.js';
import { GETTYPECODE, GETOWNERCODE, MSGSETTINGLIST, ULDSETTINGSTATION, SAVEMSGRULE, DELETERULE, SWITCHMSGRULE } from '../../../Utils/conts.js';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { MultiSelect } from 'react-multi-select-component';
import UserGrid from '../Dashboard/UserSettings.js'

export const NotificationSettings = () => {

  const isMounted = useRef(false);
  const [getTypeCodes, setGetTypeCodes] = useState([]);
  const [getDestination, setGetDestination] = useState([]);
  const [getOwnerCodes, setGetOwnerCode] = useState([]);
  const [getStationCodes, setGetStationCode] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [rulesList, setRulesList] = useState({ Rows: [], activity_status: '' });
  const [isEdit, setIsEdit] = useState('');
  const [isDelete, setIsDelete] = useState('');

  const fetchRuleList = async () => {
    try {
      const res = await withRFSToken.post(MSGSETTINGLIST, { setting_type: 'notification' });
      // .then(function (res) {
      if (res.data.response_code === 200) {
        const innerData = res.data.response_data;
        console.log(innerData);
        const transformedData = {
          ...innerData,
          activity_status: innerData.activity_status === 1 ? true : false
        };
        setRulesList(transformedData);
      } else {
        toast.error(res.data.response_msg);
      }

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchStationList = async () => {
    try {
      const res = await withRFSToken.post(ULDSETTINGSTATION, {})
        .then(function (res) {
          const innerData = res.data.response_data;
          const transformedData = innerData ? innerData.map(item => ({
            value: item.station_code,
            label: item.station_code
          })) : [];
          setGetStationCode(transformedData);
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchTypeCode = async () => {
    try {

      const res = await withRFSToken.post(GETTYPECODE, {})
        .then(function (res) {
          const innerData = res.data.response_data;
          const transformedData = innerData ? innerData.map(item => ({
            value: item.uld_typecode,
            label: item.uld_typecode
          })) : [];
          setGetTypeCodes(transformedData);
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchOwnerCode = async () => {
    try {
      const res = await withRFSToken.post(GETOWNERCODE, {})
        .then(function (res) {
          const innerData = res.data.response_data;
          const transformedData = innerData ? innerData.map(item => ({
            value: item.IATA,
            label: item.IATA
          })) : [];
          setGetOwnerCode(transformedData);
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {
    if (isMounted.current) return;
    fetchRuleList();
    fetchStationList();
    fetchTypeCode();
    fetchOwnerCode();
    isMounted.current = true;
  }, []);

  const handleCheckboxChange = async (event) => {
    // console.log("🚀 ~ handleCheckboxChange ~ event:", event)
    // setIsVisible(event.target.checked);
    if (event.target.checked === false) {
      setShowConfirmation(true);
    } else {
      if (rulesList.length > 0) {
        try {
          const res = await withRFSToken.post(SWITCHMSGRULE, { setting_type: 'notification', activity_status: 1 });
          // .then(function (res) {
          if (res.data.response_code === 200) {
            toast.success('Rules activity status updated')
            fetchRuleList();
          } else {
            toast.error(res.data.response_msg);
          }

        } catch (error) {
          console.error('Error fetching data:', error);
        }
      } else {

      }

    }
  };
  const gridRef = useRef(null);
  const [rules, setRules] = useState([
    { days: '', type_code: '', owner_code: '', station_code: [] },
  ]);

  const modalClose = () => {
    setShowModal(false);
  }
  const modalShow = (pos, data) => {
    console.log("🚀 ~ modalShow ~ data:", pos, data)
    setShowModal(true);
    setIsEdit(pos);
    if (pos == 'add') {
      setRules({ days: '', type_code: '', owner_code: '', station_code: [] })
    } else if (pos == 'edit') {
      const allCheckTC = getTypeCodes.map(item => item.value);
      const allCheckWC = getOwnerCodes.map(item => item.value);
      const allCheckSC = getStationCodes.map(item => item.value);
      const convertedData = {
        days: data.days,
        rule_id: data.rule_id,
        type_code: data.type_code == 'All' ? allCheckTC : data.type_code.split(','),
        owner_code: data.owner_code == 'All' ? allCheckWC : data.owner_code.split(','),
        station_code: data.station_code == 'All' ? allCheckSC : data.station_code.split(','),
      }
      setRules(convertedData);

    } else {
      setRules(data);
    }
  }

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setRules(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const dataCheck = () => {
    let updatedRules = { ...rules };

    if (rules.type_code) {
      console.log('type_code');
      if (rules.type_code.length === getTypeCodes.length || rules.type_code == 'All') {
        updatedRules.type_code = ['All'];
      }
    }

    if (rules.owner_code) {
      console.log('owner_code');
      if (rules.owner_code.length === getOwnerCodes.length || rules.owner_code == 'All') {
        updatedRules.owner_code = ['All'];
      }
    }

    if (rules.station_code) {
      console.log('station_code');
      if (rules.station_code.length === getStationCodes.length || rules.station_code == 'All') {
        updatedRules.station_code = ['All'];
      }
    }

    return updatedRules;
  }
  const saveRule = async () => {
    const sendData = {
      setting_type: 'message',
      rule: dataCheck(rules)
    }
    // console.log('dataCheck(rules)', dataCheck(rules));

    try {
      const res = await withRFSToken.post(SAVEMSGRULE, { setting_type: 'notification', rule_id: isEdit == 'edit' ? rules.rule_id : '', rule: dataCheck(rules) });
      // .then(function (res) {
      if (res.data.response_code === 200) {
        toast.success('Rules Added Successfully');
        setShowModal(false);
        const innerData = res.data.response_data;
        fetchRuleList()
      } else {
        toast.error(res.data.response_msg);
      }

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const deleteRule = (id) => {
    setShowConfirmation(true);
    setIsDelete(id);
  };
  const handleConfirm = async () => {
    if (isDelete !== '') {
      try {
        const res = await withRFSToken.post(DELETERULE, { rule_id: isDelete });
        // .then(function (res) {
        if (res.data.response_code === 200) {
          setShowConfirmation(false);
          fetchRuleList();
          toast.success('Rules removed successfully')
          setIsDelete('');
        } else {
          toast.error(res.data.response_msg);
        }

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    } else {
      try {
        const res = await withRFSToken.post(SWITCHMSGRULE, { setting_type: 'notification', activity_status: 0 });
        // .then(function (res) {
        if (res.data.response_code === 200) {
          setShowConfirmation(false);
          fetchRuleList();
          toast.success('Rules activity status updated')
        } else {
          toast.error(res.data.response_msg);
        }

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }

  }
  const handleModalClose = () => { setShowModal(false); }

  const SBack = localStorage.getItem('SettingsBack');

  return (
    <>
      {/* <div className=""> {console.log('is', isEdit)}
        <Header logo_url={SBack ? SBack : '/ULDControl'} sBackUrl={SBack ? SBack : '/ULDControl'} />
        <div className="page-body-wrapper schedule">
          <LeftMenu />
          <div className="main-panel">
            <div className="row">
              <LeftSettings /> */}
              <div className='col-9 col-xxl-9 stting_right'>
                <div className='settingbg_right'>
                  <h4>Notification & actions</h4>
                  <p>Set your notification preferences for when you are in or away from the dashboard.</p>

                  {/* <div className='w-55'>
                    <div className='d-flex justify-content-between align-items-center mb-3'>
                      <div className='setting_switch'>
                        <h3>Inactive ULDs</h3>
                        <p>Allow floating notification</p>
                      </div>
                      
                    </div>
                  </div> */}

                  {/* {modalIsOpen && ( */}
                  {/* <div className="stck_middle mt-2 w-55">
                    {rulesList?.Rows.length > 0 && (
                      <div className='uld_notification'>
                        <Table className=''>
                          <thead>
                            <tr>
                              <th></th>
                              <th>Inactive-Day(s)</th>
                              <th>Type Code</th>
                              <th>Owner Code</th>
                              <th>Station</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            {rulesList?.Rows.map((rule, index) => {

                              return (
                                <tr key={rule.id}>
                                  <td>{index + 1}</td>
                                  <td><span className='rule_box'> {rule.days} </span></td>
                                  <td><span className='rule_box'> {rule.type_code} </span></td>
                                  <td><span className='rule_box'> {rule.owner_code} </span> </td>
                                  <td><span className='rule_box'> {rule.station_code} </span></td>
                                  <td style={{ display: 'flex' }}>
                                    <div className='imag_trash'>
                                      <img onClick={() => modalShow('grid', rule)} src={Setting_user} alt='User Icon' />
                                    </div>
                                    <div className='imag_trash'>
                                      <img src={Edit} alt='Edit' onClick={() => modalShow('edit', rule)} />
                                    </div>
                                    <div className='imag_trash'>
                                      <img src={Trash} alt='Delete' onClick={() => deleteRule(rule.rule_id)} />
                                    </div>
                               
                                  </td>
                                 
                                </tr>
                              )
                            })}
                          </tbody>
                        </Table>

                      </div>
                    )}
                    <div className='text-end mt-3'>
                      <Button variant="primary" className='stk_add' onClick={() => modalShow('add')}>
                        <FontAwesomeIcon icon={faPlus} />Add Rule
                      </Button>
                    </div>
                  </div> */}

                  {/* )} */}
                  {/* <Modal show={showModal} onHide={handleModalClose} className='addfrom change_type' centered>
                    <Modal.Header closeButton>

                    </Modal.Header>
                    <Modal.Body>
                      <>
                        <h3>User Permission</h3>
                        <p>Processed UCM in message has an open Flight</p>
                        <Overview />
                      </>
                    </Modal.Body>
                    <Modal.Footer>
                      <>
                        <h2>byeee</h2>
                      </>
                    </Modal.Footer>
                  </Modal> */}

                </div>
              </div>
            {/* </div>
          </div> */}
          <Modal show={showModal} onHide={modalClose} centered size={isEdit == 'grid' && 'xl'} className='addfrom'>
            <Modal.Header closeButton onClick={modalClose}>
              <Modal.Title>{isEdit === 'edit' ? 'Edit Rule' : (isEdit === 'add' ? 'Add Rule' : 'User Permission')}</Modal.Title>
            </Modal.Header>
            <Modal.Body >
              {isEdit === 'grid' ?
                <>
                  <UserGrid isModal='true' ruleId={rules.rule_id} />
                </>
                :
                <>
                  <Form.Group className='mb-2'>
                    <Form.Label>Inactive-Day(s)</Form.Label>
                    <Form.Control
                      type="number"
                      value={rules.days}
                      name='days'
                      onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 3); }}
                      onChange={handleInputChange}
                    />
                  </Form.Group>
                  <Form.Group className='mb-2'>
                    <Form.Label>Type Code</Form.Label>
                    <MultiSelect
                      options={getTypeCodes}
                      value={getTypeCodes?.filter((item) => rules.type_code?.includes(item.value)) || []}
                      onChange={(selected) => {
                        const selectedIds = selected.map(item => item.value);
                        setRules((prevFormData) => ({
                          ...prevFormData,
                          type_code: selectedIds
                        }));
                      }}
                      labelledBy="Select "
                      className='multiselect'
                    />
                  </Form.Group>
                  <Form.Group className='mb-2'>
                    <Form.Label>Owner Code</Form.Label>
                    <MultiSelect
                      options={getOwnerCodes}
                      value={getOwnerCodes?.filter((item) => rules.owner_code?.includes(item.value)) || []}
                      onChange={(selected) => {
                        const selectedIds = selected.map(item => item.value);
                        setRules((prevFormData) => ({
                          ...prevFormData,
                          owner_code: selectedIds
                        }));
                      }}
                      labelledBy="Select "
                      className='multiselect'
                    />
                  </Form.Group>
                  <Form.Group className='mb-2'>
                    <Form.Label>Station</Form.Label>
                    <MultiSelect
                      // options={selectedOption}
                      // value={selectedOption.filter(option => rule.filtercriteria?.includes(option.value)) || []}
                      options={getStationCodes}
                      value={getStationCodes?.filter((item) => rules.station_code?.includes(item.value)) || []}
                      onChange={(selected) => {
                        const selectedIds = selected.map(item => item.value);
                        setRules((prevFormData) => ({
                          ...prevFormData,
                          station_code: selectedIds
                        }));
                      }}
                      labelledBy="Select "
                      className='multiselect'
                    />
                  </Form.Group>
                </>
              }

            </Modal.Body>
            <Modal.Footer>
              {isEdit !== 'grid' &&
                <Button variant="primary" onClick={saveRule}  >
                  {isEdit === 'edit' ? 'Update' : 'Add'} Rule
                </Button>
              }
            </Modal.Footer>
          </Modal>
          <Modal show={showConfirmation} onHide={() => { setShowConfirmation(false); setIsDelete('') }} className='addfrom change_type' centered>
            <Modal.Header closeButton>
            </Modal.Header>
            <Modal.Body>
              <h3>{isDelete !== '' ? 'Delete Message Rule' : 'Message Rule De-Activation'}</h3>
              <p>Are you sure you want to {isDelete !== '' ? 'Delete' : 'De-Activate'} ?</p>
            </Modal.Body>
            <Modal.Footer>
              <div className='d-flex w-50 mx-auto are_bottom'>
                <Button variant="secondary" onClick={() => setShowConfirmation(false)}>
                  No
                </Button>
                <Button variant="primary" onClick={handleConfirm}>
                  Yes
                </Button>
              </div>
            </Modal.Footer>
          </Modal>
        {/* </div>
      </div> */}
    </>
  )
}

export default NotificationSettings;